<template>
  <div class="dinA4">
    <img :src="require('@/assets/signature-header.png')" class="page__header" />
    <div class="page__container">
      <div class="d-flex justify-center">
        <p class="h1 h1--bold">Orden de domiciliación de adeudo directo SEPA B2B</p>
      </div>
      <div class="d-flex justify-end mt-2 mb-4">
        <p class="body-2 body-2--bold">Referencia de la orden de domiciliación:</p>
        <div class="dark-grey-background sepa-reference mt-1 ml-2" />
      </div>

      <table class="full-width">
        <tr class="primary-background">
          <th class="primary-background h1 color-white text-left pl-4 pb-2">
            Identificación del acreedor (a completar por el acreedor)
          </th>
          <th class="primary-background h1 color-white text-left pl-4" />
        </tr>
        <tr>
          <td class="body-1 body-1--bold">
            CTT EXPRESSO-SERVIÇOS POSTAIS E LOGISTICA S.A. SUCURSAL EN ESPAÑA
          </td>
        </tr>
        <tr>
          <td class="body-2 body-2--italic">Nombre</td>
        </tr>
      </table>

      <table>
        <tr>
          <td class="body-1 body-1--bold">W1000101D</td>
        </tr>
        <tr>
          <td class="body-2 body-2--italic">Identificador</td>
        </tr>
      </table>

      <table>
        <tr>
          <td class="body-1 body-1--bold">Avenida de Europa, nº 9</td>
          <td />
          <td class="body-1 body-1--bold pr-12">28821</td>
          <td />
          <td class="body-1 body-1--bold pl-12 pr-12">Coslada</td>
          <td />
          <td class="body-1 body-1--bold pl-12">España</td>
        </tr>
        <tr>
          <td class="body-2 body-2--italic">Dirección</td>
          <td />
          <td class="body-2 body-2--italic pr-12">Código Postal</td>
          <td />
          <td class="body-2 body-2--italic pl-12 pr-12">Ciudad</td>
          <td />
          <td class="body-2 body-2--italic pl-12">País</td>
        </tr>
      </table>

      <p class="body-2 mt-2 mb-2 justify-text">
        Mediante la firma de esta orden de domiciliación, el deudor autoriza (A) al acreedor a
        enviar instrucciones a la entidad del deudor para adeudar su cuenta y (B) a la entidad para
        efectuar los adeudos en su cuenta siguiendo las instrucciones del acreedor. Esta orden de
        domiciliación está prevista para operaciones exclusivamente entre empresas y/o autónomos. El
        deudor no tiene derecho a que su entidad le reembolse una vez que se haya realizado el cargo
        en cuenta, pero puede solicitar a su entidad que no efectúe el adeudo en la cuenta hasta la
        fecha debida. Podrá obtener información detallada del procedimiento en su entidad
        financiera.
      </p>
      <!-- tabla 2  -->
      <table class="full-width mt-2">
        <tr class="primary-background">
          <th class="primary-background h1 color-white text-left pl-4 pb-2">
            Identificación del deudor (a completar por el deudor)
          </th>
          <th class="primary-background h1 color-white text-left pl-4" />
        </tr>
        <tr>
          <td class="body-1 body-1--bold">
            {{ clientSocialReason }}
          </td>
        </tr>
        <tr>
          <td class="body-2 body-2--italic">Nombre</td>
        </tr>
      </table>

      <table>
        <tr>
          <td class="body-1 body-1--bold">
            {{ clientData.address }}
          </td>
          <td />
          <td class="body-1 body-1--bold pr-12">
            {{ clientData.postalCode }}
          </td>
          <td />
          <td class="body-1 body-1--bold pl-12 pr-12">
            {{ clientData.city }}
          </td>
          <td />
          <td class="body-1 body-1--bold pl-12">España</td>
        </tr>
        <tr>
          <td class="body-2 body-2--italic">Dirección</td>
          <td />
          <td class="body-2 body-2--italic pr-12">Código Postal</td>
          <td />
          <td class="body-2 body-2--italic pl-12 pr-12">Ciudad</td>
          <td />
          <td class="body-2 body-2--italic pl-12">País</td>
        </tr>
      </table>

      <table>
        <tr>
          <td class="body-1 body-1--bold">
            <span>{{ bankData.accountIBAN }}</span>
          </td>
          <td />
          <td class="body-1 body-1--bold pl-12 pr-12" />
          <td />
          <td class="body-2 body-2--bold pl-12">
            <span>{{ bankData.swift }}</span>
          </td>
        </tr>
        <tr>
          <td class="body-2 body-2--italic">Cuenta para recibo bancario</td>
          <td />
          <td class="body-1 body-1--bold pl-12 pr-12" />
          <td />
          <td class="body-2 body-2--italic pl-12">SWIFT BIC</td>
        </tr>
      </table>

      <table>
        <tr>
          <td class="body-1 body-1--bold">
            {{ $t(selectedPaymentMethod.desc_key) }}
          </td>
        </tr>
        <tr>
          <td class="body-2 body-2--italic">Tipo de pago</td>
        </tr>
      </table>

      <div class="d-flex justify-end mt-6 body-1">{{ legalCity }}, {{ date }}</div>
      <div class="d-flex justify-end pt-6 pb-10">
        <p :class="`body-2 body-2--italic body-2--pdf`">
          <span class="white-font">SuFirma</span>
        </p>
      </div>
      <div class="d-flex justify-end mt-2 pt-14 pb-5">
        <p class="body-2 body-2--italic">Firma Deudor</p>
      </div>
      <p class="mt-2 body-2 body-2--italic justify-text">
        Todos los campos han de ser cumplimentados obligatoriamente. Una vez firmada esta orden de
        domiciliación debe ser enviada al acreedor para su custodia. La entidad de deudor requiere
        autorización de éste previa al cargo en cuenta de los adeudos directos b2b. El deudor podrá
        gestionar dicha autorización con los medios que su entidad ponga a su disposición.
      </p>

      <Footer :page="previousPages + 1" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2024/Footer'

export default {
  name: 'Sepa',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    clientData() {
      return this[GET_OFFER_ITEM]('client')
    },
    clientSocialReason() {
      return this[GET_OFFER_ITEM]('clientSocialReason')
    },
    selectedPaymentMethod() {
      return this[GET_OFFER_ITEM]('paymentMethods').find(method => method.isSelected)
    },
    location() {
      return this[GET_OFFER_ITEM]('client').city
    },
    legalCity(){
      return this[GET_OFFER_ITEM]('legalCity');
    },
    bankData() {
      return this[GET_OFFER_ITEM]('bankDetails')
    },
    date() {
      let f = new Date()
      return 'a ' + f.getDate() + '/' + (Number(f.getMonth()) + 1) + '/' + f.getFullYear()
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('Sepa')
  },
}
</script>
